import axios from 'axios'
import api from '../api'

// Builds the client-side snapshot the BE can't derive from the request
// (user_agent/IP are read server-side, so they're intentionally omitted).
// Everything except `event` is optional; a bad write returns 202 {ok:false}
// and never hard-fails, so this action just fires and forgets.
function _Build_Payload (event, properties) {
  return {
    event: event,
    page: location.pathname,
    title: document.title,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen_width: screen.width,
    screen_height: screen.height,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    pixel_ratio: window.devicePixelRatio,
    properties: properties || null
  }
}

export const state = {}
export const mutations = {}
export const getters = {}

export const actions = {
  async track (_, { event, properties = null } = {}) {
    if (!event) return
    try {
      await axios.post(api.analytics, _Build_Payload(event, properties))
    } catch (_) {
      // swallow — analytics must never throw into the app (like error_reporter)
    }
  }
}
